import { Controller } from "@hotwired/stimulus";

/** GO4S DS — champ de tags (Entrée/virgule ajoute, Retour arrière retire). */
export default class extends Controller {
  static targets = ["input"];
  static values = { name: String };
  keydown(e) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      this.add(this.inputTarget.value.trim());
      this.inputTarget.value = "";
    } else if (e.key === "Backspace" && !this.inputTarget.value) {
      const chips = this.element.querySelectorAll(".ds-chip");
      if (chips.length) chips[chips.length - 1].remove();
    }
  }
  add(label) {
    if (!label) return;
    const chip = document.createElement("span");
    chip.className = "ds-chip ds-chip--neutral ds-chip--sm";
    chip.style.gap = "4px";
    chip.innerHTML =
      `<i data-lucide="tag" class="ds-icon"></i>${label}` +
      `<button type="button" data-action="ds-tagfield#remove" style="background:none;border:none;cursor:pointer;color:inherit;display:inline-flex;"><i data-lucide="x" class="ds-icon" style="--ds-icon-size:10px;"></i></button>`;
    if (this.nameValue) {
      const input = document.createElement("input");
      input.type = "hidden"; input.name = this.nameValue; input.value = label;
      chip.appendChild(input);
    }
    this.element.insertBefore(chip, this.inputTarget);
    if (window.g4sRenderIcons) window.g4sRenderIcons();
  }
  remove(e) { e.target.closest(".ds-chip").remove(); }
}
